import sessions from './sessions';
import invites from './invites';
import recordings from './recordings';
import authenticate from './authenticate';
import users from './users';

export default {
    sessions,
    invites,
    recordings,
    authenticate,
    users
}